import { Divider, Flex, Text } from "@mantine/core";
import DraftAutoSaveModal from "src/components/shared/_Modals/DraftAutoSaveModal/DraftAutoSaveModal";
import { BackButton } from "src/components/shared/BackButton/BackButton";
import { useIsNewEntry } from "src/hooks";
import { useSelector } from "src/redux/hooks";

import { ReadonlyFieldset } from "../../Logbook/Logbook.styled";
import ReopenNMEAModalButton from "../_Buttons/ReopenNMEAModalButton";
import SearchRefInput from "../_Buttons/SearchRefInput";
import EntryLockInfo from "../EntryLockInfo/EntryLockInfo";
import EntryText from "../EntryText";
import HamburgerMenu from "../HamburgerMenu/HamburgerMenu";
import LogBarSelects from "../LogBarSelects/LogBarSelects";
import StatusBadge from "../StatusBadge/StatusBadge";

const SmallWidthLogBar = () => {
  const { latestEntry } = useSelector(state => state.generatorSlice);
  const isNewEntry = useIsNewEntry();
  const isReadOnly = useSelector(
    state => state.generatorSlice.lbentry.isReadonly,
  );

  return (
    <>
      <Flex
        m={0}
        mih="58px"
        align="center"
        justify="space-between"
        wrap="wrap"
        gap="20px"
        mb={15}>
        <Flex direction="column">
          <Flex align="center" gap="10px">
            <BackButton />
            <Text
              ml={15}
              mr={15}
              maw={350}
              data-cy="lbname"
              style={{ textTransform: "capitalize" }}>
              {latestEntry.lbName}
            </Text>
            {latestEntry.entryref && (
              <Text maw={400} data-cy="lbentryref">
                Entry Ref. #{latestEntry.entryref}
              </Text>
            )}
            <SearchRefInput />

            <StatusBadge
              status={isNewEntry ? "new" : latestEntry.status}
              autosave={latestEntry.autosave}
              size="lg"
              variant="light"
            />
            <EntryLockInfo />
          </Flex>

          <EntryText />
        </Flex>

        <ReadonlyFieldset disabled={isReadOnly}>
          <ReopenNMEAModalButton />
          <HamburgerMenu />
        </ReadonlyFieldset>
      </Flex>

      <Flex direction="column" gap={12} align="flex-end">
        <DraftAutoSaveModal />
        <LogBarSelects gap={50} style={{ width: "100%" }} />
      </Flex>

      <Divider my="sm" />
    </>
  );
};

export default SmallWidthLogBar;
